import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui';

interface IExpandAllButtonProps {
  handleExpandAll?: () => void;
  isExpandAllEnabled?: boolean;
  allExpanded?: boolean;
}

export const ExpandAllButton: React.FunctionComponent<IExpandAllButtonProps> = ({
  isExpandAllEnabled = false,
  handleExpandAll,
  allExpanded = false,
}) => {
  const { t } = useTranslation();
  const buttonText = allExpanded
    ? t('table.collapseAll', 'Collapse All')
    : t('table.expandAll', 'Expand All');

  return (
    <Button
      data-testid="expand-all-button"
      onClick={handleExpandAll}
      disabled={!isExpandAllEnabled}
    >
      {buttonText}
    </Button>
  );
};
